/**
 * Transform functions to map v4 Team API response shapes to v3 model formats.
 * The v3 Redux reducer constructs an Immutable `Team` Record from these objects,
 * so the returned shape must match the v3 Team model constructor fields.
 */

/**
 * Maps a v4 Team to the v3 Team model shape so V3 + V4 teams can render through
 * the existing TeamPage / TeamCard UI without per-component branching.
 *
 * V4 device-link members are projected into V3's `deviceIds` array. The values
 * are V4 device UUIDs (strings) — TeamCard / device picker code resolves them
 * against `device.uuid || device.id` when matching against the device list.
 *
 * `v4Data` preserves the full V4 payload so save / link flows can read fields
 * (description, members with their link ids, etc.) that don't map cleanly to V3.
 */
export function mapV4TeamToV3(v4Team) {
    const members = Array.isArray(v4Team.members) ? v4Team.members : [];
    const deviceIds = members
        .filter(m => m && m.active !== false && m.device_id)
        .map(m => m.device_id);

    return {
        id: v4Team.id,
        name: v4Team.name || '',
        description: v4Team.description || '',
        accountName: '',
        deviceIds,
        urls: [],
        source: 'v4',
        v4Data: v4Team,
    };
}
